import { registerPlugin } from '@capacitor/core'

import type { FileDownloadPlugin } from './definitions'

const FileDownload = registerPlugin<FileDownloadPlugin>('FileDownload', {})

export * from './definitions'
export { FileDownload }
